import { Button, Modal, Divider } from "antd";
import styled from "styled-components";
import AntInput, { AntPasswordInput } from "uiKits/Input";
import { media, NAV_BREAKPOINT } from "@/theme/breakpoints";

export const MainLayout = styled.div`
  display: flex;
  width: 100%;
  min-height: 0;

  @media (max-width: ${NAV_BREAKPOINT}px) {
    flex-direction: column;
    min-height: min-content;
  }
`;

export const LeftLayout = styled.div`
  width: 60%;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const RightLayout = styled.div`
  width: 40%;
  padding: 2.25rem;
  max-height: 39.5rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;

  @media (max-width: ${NAV_BREAKPOINT}px) {
    width: 100%;
    max-height: none;
    min-height: 0;
    flex: 1;
    padding: 1.25rem 1rem 2rem;
    overflow-y: visible;
  }
`;

export const StyledModal = styled(Modal)`
  width: 56.3125rem !important;
  max-width: calc(100vw - 32px) !important;

  .ant-modal-content {
    height: 39.5rem;
    padding: unset;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .ant-modal-body {
    height: 100%;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  @media (max-width: ${NAV_BREAKPOINT}px) {
    width: calc(100vw - 24px) !important;
    top: 12px;
    padding-bottom: 0;

    .ant-modal-content {
      height: auto;
      max-height: calc(100vh - 24px);
      max-height: calc(100dvh - 24px);
      overflow: hidden;
    }

    .ant-modal-body {
      max-height: calc(100vh - 24px);
      max-height: calc(100dvh - 24px);
      overflow-y: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
    }
  }
`;

export const NameRow = styled.div`
  display: flex;
  gap: 0.75rem;
  width: 100%;

  .ant-form-item {
    flex: 1;
    min-width: 0;
  }

  @media (max-width: ${NAV_BREAKPOINT}px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const Heading = styled.h2`
  color: #6b7280;
  font-family: Inter;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
`;

export const SubHeading = styled.h5`
  color: #6b7280;
  font-family: Inter;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 121.44%; /* 1.21438rem */
  text-align: center;
`;

export const StyledButton = styled(Button)`
  border-radius: 0.25rem;
  border: 1px solid #9ca3af;
`;

export const LoginButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledDivider = styled(Divider)`
  color: #6b7280 !important;
  font-family: Inter;
  font-size: 1.25rem !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: normal;
  padding: 0 3.5rem;
  &:before {
    border: 2px solid #6b7280;
    border-block-start-color: unset !important;
  }
  &:after {
    border: 2px solid #6b7280;
    border-block-start-color: unset !important;
  }
`;

export const EmailText = styled.p`
  color: #6b7280;
  font-family: Inter;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  text-align: center;
  margin: 0;
  margin-bottom: 0.9rem;
`;

export const StyledInput = styled(AntInput)`
  height: 3.5rem;
`;

export const StyledPasswordInput = styled(AntPasswordInput)`
  height: 3.5rem;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .ant-form-item {
    margin-bottom: 0;
  }

  .ant-form-item-explain-error {
    margin-top: 0.25rem;
  }
`;

export const StyledContinueButton = styled(Button)`
  width: 11.875rem;
  max-width: 100%;
  height: 2.5rem;
  min-height: 44px;
  border-radius: 0.3125rem;
  background: #ed6928;
  color: var(--White-background, var(--Color-Neutral-white, #fff));
  text-align: center;
  font-family: Inter;
  font-size: 0.8535rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 1.81rem;
  &:hover {
    color: #ed6928 !important;
    background: #ffffff !important;
    border-color: #ed6928 !important;
  }
`;

export const TermAndConditionsText = styled.p`
  color: #6b7280;
  text-align: center;
  font-family: Inter;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.06263rem;
  margin: 0;
  margin-top: 1.44rem;
  padding-bottom: 0.5rem;

  ${media.downMobile`
    font-size: 0.8125rem;
    margin-top: 1rem;
  `}
`;

// Switch between login / signup text container
export const SwitchAuthText = styled.p`
  color: #6b7280;
  text-align: center;
  font-family: Inter;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.06263rem;
  margin: 0.75rem 0 0; 
`;

export const SwitchAuthLink = styled.span`
  color: #ed6928;
  cursor: pointer;
  font-weight: 600;
  margin-left: 0.35rem;
  &:hover {
    text-decoration: underline;
  }
`;
